<template>
    <div class="col-md-6 p-0 mr-5">
        <div class="calculator__step">
            <div class="calculator__step--top">
                <b>STORAGE CALCULATOR</b>
            </div>
            <div class="row m-0 calculator__step--content pl-4 pr-4 pt-4">
                <div class="col-md-3" style="color: #1D3354;">
                    <h3>Step 5</h3>
                    <p> Step 5 from 5 </p>
                </div>
                <div class="col-md">
                    <b-form-group class="customdropdown">
                        <div class="row m-0 label pb-2">
                          <b>Expected Days</b>
                          <div class="__errorMsg text-left ml-2"> {{expected_message}} </div>
                        </div>
                        <b-dropdown>
                            <template slot="button-content">
                            {{ expectedValue}}
                            </template>
                            <b-dropdown-item @click="selectedOption(item)" v-for="(item,i) in optionsExpectedDays" :key="i" >
                                <span>{{ item.text }}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                        <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
                    </b-form-group>
                </div>
            </div>
            <div class="row m-0 calculator__step--bottom justify-content-end p-4 pt-5">
                <button class="_global__button--corporite pl-4 pr-4"  @click="emitToParent('CalcStep4')">Back</button>
                <button class="_global__button--corporite pl-4 pr-4 ml-4"  @click="emitToParent('ResultCalculator')">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CalcStep2',
  props: {
    mainData: Object
  },
  data: () => ({
    expectedValue: 'Choose Expected Days',
    expected_message: '',
    form: {
      stepName: '',
      expectedDays: ''
    },
    optionsExpectedDays: [
      { text: '3 Days', value: 3 },
      { text: '6 Days', value: 6 },
      { text: '9 Days', value: 9 },
      { text: '12 Days', value: 12 },
      { text: '15 Days', value: 15 },
      { text: '18 Days', value: 18 },
      { text: '21 Days', value: 21 },
      { text: '24 Days', value: 24 },
      { text: '27 Days', value: 27 },
      { text: '30 Days', value: 30 }
    ],
    payloadLog: {
      featureName: 'STORAGE CALCULATOR',
      featureStep: 5,
      stepName: 'Random Checking, Importer Age',
      featureProcess: {
        status: 'success',
        data: {}
      }
    }
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // insert log
      this.payloadLog.featureProcess.data = this.form
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    emitToParent (data) {
      if (data === 'CalcStep4') {
        this.form.stepName = data
        this.$emit('activeForm', this.form)
      } else if (this.form.expectedDays) {
        this.form.stepName = data
        const totalValues = parseInt(this.mainData.completeness) + parseInt(this.mainData.historic) + parseInt(this.mainData.importerAge) + parseInt(this.mainData.productType) + parseInt(this.mainData.randomChecking)
        this.$emit('sumValue', totalValues)
        this.$emit('activeForm', this.form)
      } else { this.expected_message = 'This field is required*' }
    },
    selectedOption (item) {
      this.expectedValue = item.text
      this.form.expectedDays = item.value
      this.expected_message = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/storagecalculator/CalcStep5.vue